var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynergetic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2764 49.1408L41.0901 90.1357C40.6855 90.5684 40.1513 90.8575 39.5683 90.9594C38.9852 91.0612 38.385 90.9703 37.858 90.7003C37.3311 90.4304 36.9061 89.996 36.6471 89.4628C36.3882 88.9296 36.3094 88.3264 36.4225 87.7444L41.4208 62.6931L21.772 55.3003C21.35 55.1421 20.9737 54.8817 20.6767 54.5423C20.3796 54.2028 20.1712 53.7949 20.0699 53.3551C19.9685 52.9152 19.9776 52.457 20.0961 52.0215C20.2146 51.586 20.439 51.1866 20.7491 50.8592L58.9354 9.86428C59.34 9.43157 59.8742 9.14247 60.4572 9.04062C61.0403 8.93877 61.6405 9.02968 62.1675 9.29965C62.6944 9.56962 63.1194 10.004 63.3784 10.5372C63.6373 11.0704 63.7161 11.6736 63.603 12.2557L58.591 37.3343L78.2399 44.7168C78.6588 44.876 79.032 45.1362 79.3268 45.4743C79.6215 45.8123 79.8285 46.218 79.9296 46.6553C80.0307 47.0926 80.0228 47.5481 79.9065 47.9816C79.7902 48.4151 79.5691 48.8133 79.2627 49.1408H79.2764Z",
    fill: "#31D054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynergetic);
export default __webpack_public_path__ + "static/media/synergetic.75c2cceca9d150896146d38068d05e25.svg";
export { ForwardRef as ReactComponent };